import { useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../../../../common/html/element'
import { EMPTY_VALUE } from '../../../../../../utils/common'
import { TableGeneralAnalysis } from '../../common/table'
import {
  selectFinancialRatiosCellData,
  selectFinancialRatiosData,
  selectFinancialRatiosIds,
  selectFinancialRatiosRowGroup,
  selectGenericRatioHighlight,
  selectLoading,
} from '../../store/slice'

const FinancialRatios = ({ isDynamicReport, settingDynamic = {} }) => {
  const loading = useSelector(selectLoading('financialRatios'))
  const genericRatioHighlight = useSelector(selectGenericRatioHighlight)
  const ids = useSelector(selectFinancialRatiosIds)

  return (
    <div>
      <Element style={{ fontSize: 14, fontWeight: 600, marginBottom: 14 }}>
        <Translate
          value="companyAnalysis.industryAnalysis.FINANCIAL_RATIOS"
          prevReportYear={genericRatioHighlight?.prevReportYear || EMPTY_VALUE}
          currentReportYear={
            genericRatioHighlight?.currentReportYear || EMPTY_VALUE
          }
        />
      </Element>
      <div style={{ height: 430 }}>
        <TableGeneralAnalysis
          isDynamicReport={isDynamicReport}
          settingDynamic={settingDynamic}
          dataTable={{
            loading,
            ids,
            selectCellData: selectFinancialRatiosCellData,
            selectData: selectFinancialRatiosData,
            selectRowGroup: selectFinancialRatiosRowGroup,
          }}
        />
      </div>
    </div>
  )
}

export default FinancialRatios
